import { useInView } from "../hooks/useInView";
import { RevealChild } from "./Reveal";
import { FiArrowUpRight } from "react-icons/fi";

const areas = [
  {
    title: "AWS & Cloud Infrastructure",
    body: "Account structure, IAM, ECS/EKS patterns, scalable networking, resilient deployments, and cost-aware architecture.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "DevSecOps & Security",
    body: "Secrets scanning, SAST, policy checks, WAFs, secure access, and vulnerability feedback built into delivery.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "CI/CD Pipelines",
    body: "GitHub Actions, GitLab CI, release gates, deployment controls, and developer-friendly automation.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "Kubernetes & Containers",
    body: "Cluster operations, Docker, ECS, workload security, production readiness, and cloud-native runbooks.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "Observability",
    body: "Prometheus, Grafana, Loki, alert design, service health, and incident context across distributed systems.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "Terraform / IaC",
    body: "Reusable modules, drift awareness, secure defaults, environment promotion, and reviewable infrastructure changes.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "Developer Workflows",
    body: "Practical systems that reduce toil, improve feedback loops, and help engineers ship without losing control.",
    url: "https://brain.rakeshkadam.me",
  },
  {
    title: "AI for DevOps / AIOps",
    body: "Claude Code, LLM agents for IaC generation, incident triage, and automated synthesis of operational knowledge.",
    url: "https://brain.rakeshkadam.me",
  },
];

const ExpertiseGrid = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  return (
    <section className="py-12 text-light-text dark:text-text-primary" ref={ref}>
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <RevealChild visible={inView} delay={0}>
          <div className="mb-10">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent mb-3">
              Expertise
            </p>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight max-w-2xl tracking-tight">
              The work spans{" "}
              <span className="text-accent">architecture and execution.</span>
            </h2>
            <p className="text-base md:text-lg leading-relaxed max-w-2xl text-light-muted dark:text-text-muted">
              Infrastructure that can scale, pipelines that can be trusted, and
              operations that make real incidents less surprising.
            </p>
          </div>
        </RevealChild>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {areas.map((area, i) => (
            <RevealChild
              key={area.title}
              visible={inView}
              delay={60 + i * 50}
            >
              <a
                href={area.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group block h-full rounded-xl border border-light-border bg-light-surface p-5 transition-all duration-300 hover:border-accent/20 dark:border-border-subtle dark:bg-surface-1"
              >
                <h3 className="mb-2 text-sm font-semibold group-hover:text-accent transition-colors leading-snug">
                  {area.title}
                </h3>
                <p className="text-xs leading-relaxed text-light-muted dark:text-text-muted mb-4">
                  {area.body}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-accent opacity-0 group-hover:opacity-100 transition-opacity">
                  Explore
                  <FiArrowUpRight size={12} />
                </span>
              </a>
            </RevealChild>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseGrid;
